module.exports = __webpack_public_path__ + "media/images/logo-square-003666e603ff561ec0371ba225cecf90.jpg";